<main class="main">
  <app-egg-spinner-overlay></app-egg-spinner-overlay>
</main>
